































































































































































import { Component, Vue, BasePage } from "@/common";

import { TwTable } from "@/components";

import moment from "moment";

@Component({})
export default class User extends BasePage {
  editing: boolean = false;

  saveMask: boolean = false;

  isModify: boolean = false;

  user = {
    ID: null,
    TenantId: null,
    UserId: "",
    cName: "",
    cEmail: "",
    cPhone: "",
    iSex: null,
    cAddress: "",
    userType: "",
    GlobalScan: 0,
    CopName: "",
    cardNum: "",
    iStatus: 1,
  };

  rules = {
    UserId: [
      { required: true, message: "请输入用户账户", trigger: "blur" },
      {
        min: 2,
        max: 15,
        message: "长度在 2 到 15 个字符之间",
        trigger: "blur",
      },
    ],
    cName: [
      { required: true, message: "请输入用户名称", trigger: "blur" },
      {
        min: 2,
        max: 15,
        message: "长度在 2 到 15 个字符之间",
        trigger: "blur",
      },
    ],
    cEmail: [
      { type: "email", message: "请输入正确的邮箱格式", trigger: "blur" },
    ],

    cPhone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          // 这个只能验证手机号
          { min: 11,max: 11, message: "请输入合法手机号", trigger: "blur" }
          //{ pattern:/^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/, message: "请输入合法手机号/电话号", trigger: "blur" }
        ],
  };

  companyOptions = [
    {
      value: "万佳",
      label: "万佳",
    },
    {
      value: "汇聚万佳",
      label: "汇聚万佳",
    }
  ];

  typeOptions = [
    {
      value: "行政",
      label: "行政",
    },
    {
      value: "提货司机",
      label: "提货司机",
    },
    {
      value: "送货司机",
      label: "送货司机",
    },
    {
      value: "客户",
      label: "客户",
    },
  ];

  columns = [
    {
      prop: "UserId",
      label: "用户账号",
      align: "center",
      width: 120,
      attrs: {
        type: "string",
      },
    },
    {
      prop: "cName",
      label: "姓名",
      align: "center",
      width: 120,
      attrs: {
        type: "string",
      },
    },
    {
      prop: "cEmail",
      label: "邮件",
      align: "center",
      width: 180,
      attrs: {
        type: "string",
      },
    },
    {
      prop: "userType",
      label: "用户类型",
      align: "center",
      width: 100,
      attrs: {
        type: "string",
      },
    },
    {
      prop: "cPhone",
      label: "联系电话",
      align: "center",
      width: 180,
      attrs: {
        type: "string",
      },
    },
    {
      prop: "cardNum",
      label: "身份证号码",
      align: "center",
      width: 200,
      attrs: {
        type: "string",
      },
    },
    {
      prop: "CopName",
      label: "所属公司",
      align: "center",
      width: 150,
      attrs: {
        type: "string",
      },
    },
    {
      prop: "iStatus",
      label: "状态",
      align: "center",
      width: 100,
      attrs: {
        type: "number",
      },
      render: this.renderEnabled,
    },
    {
      label: "操作",
      align: "center",
      width: 100,
      render: this.renderOperation,
    },
  ];

  get table(): TwTable {
    return this.$refs["usertable"] as TwTable;
  }

  add() {
    this.isModify = false;
    this.editing = true;
    this.resetForm("userForm");
    // 因为ID未在form表单绑定输入元素,所以resetForm不会重置ID,如果后台需要根据ID做一些判断,可以在这里手动置空
    this.user.ID = null;
  }

  modify() {
    this.isModify = true;
    this.editing = true;
    this.resetForm("userForm");
    this.loadForm(this.user, this.table.getCurrentRow());
  }

  save() {
    this.isFormValid("userForm", (valid) => {
      if (valid) {
        this.saveMask = true;
        this.$http
          .post("Base/User/Save", { user: this.user })
          .then((res) => {
            if (res.data.status === 0) {
              this.saveMask = false;
              this.editing = false;
              this.$message.success("操作成功");
              this.table.reload();
            } else {
              this.saveMask = false;
              this.$message.warning(res.data.msg || "操作失败");
            }
          })
          .catch((err) => {
            this.$message.warning(err);
          });
      }
    });
  }

  deleteRows() {
    this.$http
      .post("Base/User/Delete", {
        delIds: this.table.getSelections().map((item) => item.ID),
      })
      .then((res) => {
        if (res.data.status === 0) {
          this.$message.success("删除成功");
          this.table.reload();
        } else {
          this.$message.warning(res.data.msg || "操作失败");
        }
      });
  }

  load() {
    this.table.load();
  }

  // 列渲染  使用jsx方式渲染 必须使用函数方式实现 不支持箭头函数和function函数
  renderEnabled(props) {
    switch (props.row.iStatus) {
      case 0:
        return <span style="color:grey">停用</span>;
      case 1:
        if (
          props.row.dUnlockDate &&
          this.$moment(props.row.dUnlockDate).toDate() > this.$moment().toDate()
        ) {
          return <span style="color:blue">锁定</span>;
        }
        return <span style="color:green">启用</span>;
    }
  }

  // 通过列渲染方式实现之定义列
  renderOperation(props) {
    if (
      props.row.dUnlockDate &&
      this.$moment(props.row.dUnlockDate).toDate() > this.$moment().toDate() &&
      props.row.iStatus === 1
    ) {
      return (
        <div>
          <el-tooltip content="解锁用户" hide-after={700} placement="bottom">
            <el-button
              style="padding:7px;"
              type="primary"
              onClick={() => {
                this.$confirm(`确定解锁当前用户么?`, "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                  .then(() => {
                    this.$http
                      .post("Base/User/AlterStatus", {
                        iStatus: 2,
                        ID: props.row.ID,
                      })
                      .then((res) => {
                        props.row._unlockPop = 0;
                        props.row.dUnlockDate = null;
                      });
                  })
                  .catch(() => {});
              }}
            >
              解
            </el-button>
          </el-tooltip>
        </div>
      );
    } else {
      return (
        <div>
          <el-tooltip
            content={props.row.iStatus === 1 ? "停用用户" : "启用用户"}
            hide-after={700}
            placement="bottom"
          >
            <el-button
              style="padding:7px;"
              type={props.row.iStatus === 1 ? "danger" : "success"}
              v-show={props.row.iStatus !== 2}
              onClick={() => {
                this.$confirm(
                  `确定${props.row.iStatus === 1 ? "停用" : "启用"}当前用户么?`,
                  "提示",
                  {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                  }
                )
                  .then(() => {
                    const iStatus = props.row.iStatus === 1 ? 0 : 1;
                    this.$http
                      .post("Base/User/AlterStatus", {
                        iStatus: iStatus,
                        ID: props.row.ID,
                      })
                      .then((res) => {
                        props.row._showPop = 0;
                        props.row.iStatus = iStatus;
                      });
                  })
                  .catch(() => {});
              }}
            >
              {props.row.iStatus === 1 ? "停" : "启"}
            </el-button>
          </el-tooltip>
        </div>
      );
    }
  }
}
